import {Component, OnInit, OnDestroy} from '@angular/core';
import {UntypedFormBuilder, FormArray, Validators, UntypedFormGroup, FormControl} from '@angular/forms';
import {Router, ActivatedRoute} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import * as moment from 'moment';
import {SharedService} from '../../shared.service';
import {CitytownService} from '../../../modules/systemconfig/citytown/citytown.service';
import {DistrictService} from '../../../modules/systemconfig/district/district.service';
import {OrganizationService} from '../../../modules/systemconfig/organization/organization.service';
import {ClassesService} from '../../../modules/academics/classes/classes.service';

import {RelationshipService} from '../../../modules/systemconfig/relationship/relationship.service';
import {ReligionService} from '../../../modules/systemconfig/religion/religion.service';
import {NationalityService} from '../../../modules/systemconfig/nationality/nationality.service';



interface CarouselItem {
  image: string;
  text: string;
}

@Component({
	selector: 'app-parent_account_registration',
	templateUrl:'../pages/regform_schoolinfo.component.html'
})


export class ParentAccountRegistrationComponent implements OnInit {

	isLoading = false;

	
	schoolname:any;
	schoolemail:any;
	school_info:any;
	schoolphone:any;
	schooladdress:any; 
	schoollogo:any;
	schooladdressline: any;
	schoolwebsite: any;

	school:any ;




	constructor(
		private toastr: ToastrService,
		private fb: UntypedFormBuilder,
		private route: ActivatedRoute,
		private sharedService: SharedService,
		private router: Router,
		private districtservice:DistrictService,
		private citytownservice:CitytownService,
		private organizationservice:OrganizationService,
		private classesservice: ClassesService,
		private relationshipService:RelationshipService,
		private religionService:ReligionService,
		private nationalityService:NationalityService) {
	}
	carouselItems: CarouselItem[] = [
	    { image: 'https://wallpaperaccess.com/full/4521348.jpg', text: 'Text 1' },
	    { image: 'https://img.freepik.com/free-photo/ready-back-school_1134-12.jpg', text: 'Text 2' },
	    { image: 'https://firstpathedu.com/wp-content/uploads/2023/05/Same-12.jpg', text: 'Text 3' }
  	];

	images = ['https://wallpaperaccess.com/full/4521348.jpg', 'https://img.freepik.com/free-photo/ready-back-school_1134-12.jpg', 'https://firstpathedu.com/wp-content/uploads/2023/05/Same-12.jpg'];
  	currentSlide = 0;

  	nextSlide() {
    	this.currentSlide = (this.currentSlide + 1) % this.carouselItems.length;
    	console.log(this.currentSlide)
  	}

  	prevSlide() {
    	this.currentSlide = this.currentSlide > 0 ? this.currentSlide - 1 : this.images.length - 1;
  	}


	ngOnInit() {
		setInterval(() => this.nextSlide(), 7000);
		this.isLoading = true;
		this.getschoolname();

	}

	public getschoolname() {
		this.organizationservice.getactiveorganization().subscribe((data: any) => {
			this.school = data[0];
			// this.schoolname = this.school['org_name'];
			// this.schoolemail = this.school['org_email'];
			// this.schoolphone = this.school['org_phone'];
			// this.schooladdress = this.school['org_address_line1'];
			// this.schooladdressline = this.school['org_address_line2'];
			// this.schoolwebsite = this.school['org_website'];
			// this.schoollogo = this.school['org_logo'];
			// const element = document.getElementById('institute_info');
			// element.innerHTML = this.school['institute_info'];
		 });
	}
}
